// eslint-disable-next-line
const apiHost = process.browser ? process.env.apiHostBrowser : process.env.apiHostServer;

export default {
    GET_PRODUCTS_DATA_URL: `${apiHost}/catalog/product_compare/getData/`,
};
